import React, { useContext, useMemo, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Divider,
  InputAdornment,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";

import GeneralContext from "../GeneralContext/GeneralContext";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";

const FAQ_CONTENT = [
  {
    "sectionId": "sec-1",
    "sectionTitle": "1. ¿QUÉ ES SAGEC Y PARA QUÉ SIRVE?",
    "items": [
      {
        "id": "q-1.1",
        "q": "¿Qué es SAGEC?",
        "aBlocks": [
          {
            "type": "p",
            "text": "SAGEC es el Servicio de Administración y Gestión de Conectividad. Es una plataforma que permite hacer seguimiento técnico y comercial al servicio de conectividad provisto a los establecimientos educacionales, apoyando la supervisión de SUBTEL y MINEDUC."
          }
        ]
      },
      {
        "id": "q-1.2",
        "q": "¿Para qué sirve SAGEC a los establecimientos educacionales?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Permite realizar varias acciones:"
          },
          {
            "type": "ul",
            "items": [
              "Completar formularios de alta de servicio (FAS) validando el servicio instalado por el proyecto por primera vez para iniciar el servicio obligatorio;",
              "Completar formularios de upgrade de servicio (FUS) validando el establecimiento educacional el aumento de ancho de banda del servicio en los períodos obligatorios; ● Validar contingencias, las cuales son generadas por interrupciones o afectaciones del servicio de conectividad."
            ]
          }
        ]
      },
      {
        "id": "q-1.3",
        "q": "¿Qué información del establecimiento se muestra en SAGEC?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Se muestra información general del establecimiento, datos del servicio de conectividad, contingencias registradas y estados asociados a la validación de éstas."
          }
        ]
      },
      {
        "id": "q-1.4",
        "q": "¿Dónde puedo encontrar el manual de la plataforma SAGEC?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Existen actualmente dos manuales; uno genérico de la plataforma y el segundo manual es sobre el proceso de contingencias. Ambos se encuentran disponibles en el sitio del proyecto “Conectividad para la Educación 2030” en conectividad2030.cl."
          }
        ]
      },
      {
        "id": "q-1.5",
        "q": "¿SAGEC reemplaza otros canales de comunicación con la empresa proveedora?",
        "aBlocks": [
          {
            "type": "p",
            "text": "No. SAGEC no reemplaza los canales habituales de comunicación con la empresa proveedora del servicio. La plataforma solo es un medio por parte de la empresa proveedora, para respaldar formalmente contingencias y validaciones, pero no sustituye la comunicación directa ante fallas o coordinaciones operativas provista por las mesas de ayuda."
          }
        ]
      }
    ]
  },
  {
    "sectionId": "sec-2",
    "sectionTitle": "2. ACCESO, USUARIOS Y SOPORTE",
    "items": [
      {
        "id": "q-2.1",
        "q": "¿Cómo ingreso a la plataforma SAGEC?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Debe ingresar a https://sagec.subtel.gob.cl utilizando su RUN y Clave Única del Estado."
          }
        ]
      },
      {
        "id": "q-2.2",
        "q": "¿Qué hago si no puedo ingresar porque mi usuario no existe?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Debe escribir un correo a conectividad@innovacion.mineduc.cl indicando RBD, nombre completo, RUN, correo electrónico y cargo, para que el equipo a cargo del proyecto en MINEDUC cree el usuario en la plataforma."
          }
        ]
      },
      {
        "id": "q-2.3",
        "q": "¿Quiénes pueden acceder a SAGEC?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Principalmente el/la Director/a del establecimiento y el Encargado/a de Informática, quienes cuentan con el perfil “Rol Representante”. En general, a la plataforma pueden ingresar los Operadores con sus técnicos, profesionales de SUBTEL y MINEDUC, teniendo diferentes perfiles cada uno."
          }
        ]
      },
      {
        "id": "q-2.4",
        "q": "¿Cuáles perfiles de usuario existen en SAGEC y qué puede hacer cada uno?",
        "aBlocks": [
          {
            "type": "p",
            "text": "En SAGEC existen distintos perfiles. Para los establecimientos educacionales, el principal es el Rol Representante, asignado al Director/a y/o Encargado/a de Informática. Este perfil permite revisar, aprobar o rechazar contingencias y validar información asociada al servicio de conectividad."
          }
        ]
      },
      {
        "id": "q-2.5",
        "q": "¿Puede un establecimiento tener más de un Rol Representante?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Sí. Un establecimiento puede contar con más de una persona con Rol Representante, lo que permite asegurar continuidad operativa en la revisión y validación de contingencias."
          }
        ]
      },
      {
        "id": "q-2.6",
        "q": "¿Qué significa Representante Temporal?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Corresponde a una persona que atiende al técnico de la empresa proveedora, ya sea en una visita en terreno o por contacto telefónico con el establecimiento educacional, la cual no se encuentra registrada en la plataforma. En estos casos, el técnico la puede registrar quedando como “Representante Temporal” y MINEDUC valida a la persona antes de cerrar la contingencia."
          }
        ]
      },
      {
        "id": "q-2.7",
        "q": "¿Qué hago si cambió el/la Director/a o el Encargado/a TI del establecimiento?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Se debe solicitar la actualización del usuario enviando un correo a conectividad@innovacion.mineduc.cl, indicando RBD, nombre completo, RUN, correo electrónico y cargo de la nueva persona responsable. Además dentro de la misma plataforma el nuevo Rol podrá deshabilitar a la persona que ya no cumple funciones en el establecimiento educacional."
          }
        ]
      },
      {
        "id": "q-2.8",
        "q": "¿Qué sucede si la persona con Rol Representante está con licencia o vacaciones?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Si existe otro Rol Representante activo, este puede asumir las funciones. En caso contrario, se podrá designar a un Representante Temporal que el técnico de la empresa proveedora registrará, el cual será validado posteriormente por el Ministerio de Educación."
          }
        ]
      },
      {
        "id": "q-2.9",
        "q": "¿Cómo se valida la información del Rol Representante Temporal en SAGEC?",
        "aBlocks": [
          {
            "type": "p",
            "text": "2 La validación se realiza con información oficial del establecimiento, principalmente a través de registros administrativos del Ministerio de Educación (SIGE) y en el caso de que la persona no se encuentre, se envía correo electrónico a Director/a para validar a la persona."
          }
        ]
      },
      {
        "id": "q-2.10",
        "q": "¿A quién debo contactar si tengo problemas con SAGEC?",
        "aBlocks": [
          {
            "type": "ul",
            "items": [
              "Si tiene problemas dentro de la plataforma con algún FAS, FUS o Contingencias se puede contactar con Ayuda y Soporte de SAGEC, en el menú azul en “Ayuda”. ● Para temas de acceso o usuarios, escribir a conectividad@innovacion.mineduc.cl. ● Para problemas del servicio, contactar a la empresa proveedora a la Mesa de Ayuda correspondiente."
            ]
          }
        ]
      },
      {
        "id": "q-2.11",
        "q": "¿Qué hago si olvido mi ClaveÚnica o tengo problemas para autenticarme?",
        "aBlocks": [
          {
            "type": "p",
            "text": "En estos casos, el representante del establecimiento debe gestionar la recuperación o regularización de la ClaveÚnica a través de los canales oficiales correspondientes. Una vez resuelto el acceso, podrá ingresar normalmente a la plataforma SAGEC."
          }
        ]
      }
    ]
  },
  {
    "sectionId": "sec-3",
    "sectionTitle": "3. USO GENERAL DE LA PLATAFORMA",
    "items": [
      {
        "id": "q-3.1",
        "q": "¿Con qué frecuencia debe el establecimiento revisar la plataforma SAGEC?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Se recomienda revisar la plataforma de manera periódica de manera mensual o cuando se haya producido una interrupción del servicio de conectividad, considerando el desfase entre el corte y la creación de la contingencia."
          }
        ]
      },
      {
        "id": "q-3.2",
        "q": "¿SAGEC funciona en todos los navegadores?",
        "aBlocks": [
          {
            "type": "p",
            "text": "SAGEC funciona correctamente en los navegadores más utilizados y actualizados (Chrome, Edge, Firefox). Se recomienda mantener el navegador actualizado."
          }
        ]
      },
      {
        "id": "q-3.3",
        "q": "¿Puedo acceder a SAGEC desde un celular o Tablet?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Sí, la plataforma es accesible desde dispositivos móviles, aunque para una mejor visualización y revisión de información se recomienda usar un computador."
          }
        ]
      },
      {
        "id": "q-3.4",
        "q": "¿El establecimiento puede modificar datos directamente en la plataforma?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Los datos de personas que tiene Rol Representante si se pueden modificar agregando o deshabilitando a una persona. Los datos estructurales del establecimiento no pueden ser modificados directamente. Cualquier corrección debe solicitarse por los canales de soporte correspondientes."
          }
        ]
      },
      {
        "id": "q-3.5",
        "q": "¿SAGEC envía notificaciones cuando hay acciones pendientes?",
        "aBlocks": [
          {
            "type": "p",
            "text": "No. La plataforma no envía notificaciones, la empresa le debe informar sobre estas contingencias y MINEDUC a través del correo conectividad@innovacion.mineduc.cl, envía correos a los Representantes registrados y al correo del Director/a y su Coordinador de Informática para que ingresen a la plataforma porque tienen contingencias sin resolver. Por lo cual se solicita al establecimiento revisar mensualmente SAGEC."
          }
        ]
      },
      {
        "id": "q-3.6",
        "q": "¿Qué ocurre si el establecimiento no revisa la plataforma periódicamente?",
        "aBlocks": [
          {
            "type": "p",
            "text": "3 La falta de revisión provoca retrasos en el pago del servicio. Por lo cual Mineduc estará constantemente enviando correos a los involucrados, con usuario en la plataforma + Director/a y Coordinador/a de Informática. Si no tiene contingencias asociadas Mineduc no enviará correos."
          }
        ]
      }
    ]
  },
  {
    "sectionId": "sec-4",
    "sectionTitle": "4. CONTINGENCIAS: REGISTRO, REVISIÓN Y VALIDACIÓN",
    "items": [
      {
        "id": "q-4.1",
        "q": "¿Qué es una contingencia?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Es un evento que provoca la suspensión o afectación del servicio de conectividad por un periodo determinado, ya sea por causas internas del establecimiento o externas a este."
          }
        ]
      },
      {
        "id": "q-4.2",
        "q": "¿Qué tipos de contingencias existen?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Existen contingencias de tipo programadas, específicas internas, específicas externas y zonales. Dependiendo de cada tipo es el Rol que resuelve la contingencia."
          }
        ]
      },
      {
        "id": "q-4.3",
        "q": "¿Qué es una contingencia programada?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Es un corte de servicio acordado previamente entre la empresa proveedora y el establecimiento, generalmente recurrente y planificado. Por ejemplo, si el establecimiento desconecta los equipos al cierre de la jornada diaria, se puede informar a la empresa que apagan los equipos de lunes a viernes entre 16:00 y 07:59 horas, ya que esto se repite en el tiempo."
          }
        ]
      },
      {
        "id": "q-4.4",
        "q": "¿Quién aprueba una contingencia programada?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El establecimiento educacional, a través del Rol Representante. Se recuerda que es importante revisar bien el detalle ingresado por el técnico, en el horario o los días en que se genera este corte programado y que coincida con la realidad si hay algo que no corresponde se debe Rechazar."
          }
        ]
      },
      {
        "id": "q-4.5",
        "q": "¿Qué es una contingencia específica interna?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Es un evento imprevisto y no recurrente ocurrido dentro del establecimiento, que afecta el servicio de conectividad y cuya responsabilidad recae en el establecimiento. Por ejemplo, en el establecimiento suspendieron clases por día del profesor o se corto la energía por trabajos internos en el establecimiento."
          }
        ]
      },
      {
        "id": "q-4.6",
        "q": "¿Qué es una contingencia específica externa?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Es un evento imprevisto y externo al establecimiento que afecta el servicio. Estas contingencias son validadas por SUBTEL. Por ejemplo, que chocaron un poste fuera del establecimiento y provoco el corte del servicio."
          }
        ]
      },
      {
        "id": "q-4.7",
        "q": "¿Qué es una contingencia zonal?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Es una afectación del servicio que impacta a un conjunto de establecimientos de una zona determinada y es validada por SUBTEL. Por ejemplo, corte de luz masivo."
          }
        ]
      },
      {
        "id": "q-4.8",
        "q": "Una vez producido el corte del servicio ¿cuál es el plazo para que aparezca registrada como una contingencia en la plataforma?",
        "aBlocks": [
          {
            "type": "p",
            "text": "4 El registro de una contingencia en SAGEC no es inmediato y depende del ingreso que realice la empresa proveedora del servicio, teniendo la empresa como plazo un mes desde ocurrido el corte. Por lo que existirá un desfase máximo de un mes entre el corte y la visualización de la contingencia en la plataforma."
          }
        ]
      },
      {
        "id": "q-4.9",
        "q": "¿Qué pasa si no apruebo ni rechazo una contingencia?",
        "aBlocks": [
          {
            "type": "p",
            "text": "La contingencia permanecerá en estado “En proceso”, si dentro del mes de plazo no se responde Mineduc deberá resolverla “Aprobando” y/o “Rechazando”, lo que puede afectar la correcta validación del servicio. Por ello, es importante que los establecimientos educacionales puedan revisarlas oportunamente."
          }
        ]
      },
      {
        "id": "q-4.10",
        "q": "¿Existe un plazo para aprobar o rechazar una contingencia?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Sí. Las contingencias deben revisarse a la brevedad para asegurar una correcta gestión y el pago del servicio. Esto es por ejemplo, contingencias de marzo, la empresa tiene como plazo poder ingresarlas hasta abril y el establecimiento debe revisar hasta mayo, para su pago en junio."
          }
        ]
      },
      {
        "id": "q-4.11",
        "q": "¿Qué pasa si rechazo una contingencia?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Al rechazar una contingencia, esta no queda validada y la empresa proveedora debe revisar y corregir la información o ingresar una nueva contingencia, según corresponda."
          }
        ]
      },
      {
        "id": "q-4.12",
        "q": "¿Puedo rechazar una contingencia más de una vez?",
        "aBlocks": [
          {
            "type": "p",
            "text": "No, las contingencias se cierran una vez que se rechazan (o aprueban). El técnico de la empresa proveedora podrá volver a ingresar nuevamente la contingencia para justificar el corte, pero si esta sigue teniendo la misma información que la anterior, el establecimiento educacional puede seguir rechazándola, por eso es importante que cuando se rechace una contingencia indique la razón, para que si el técnico la vuelve a ingresar venga con esa corrección si es que aplica."
          }
        ]
      },
      {
        "id": "q-4.13",
        "q": "¿Qué consecuencias tiene aprobar una contingencia que no corresponde?",
        "aBlocks": [
          {
            "type": "p",
            "text": "La aprobación implica validar que la información es correcta. Aprobar una contingencia incorrecta puede afectar los registros oficiales del servicio."
          }
        ]
      },
      {
        "id": "q-4.14",
        "q": "¿Qué ocurre si la empresa no ingresa una contingencia cuando hubo corte?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El establecimiento debe informar la situación a la empresa proveedora –mediante la mesa de ayuda- para que regularice el registro correspondiente. La plataforma Sagec no es para este tipo de situaciones."
          }
        ]
      },
      {
        "id": "q-4.15",
        "q": "¿Cómo saber si una contingencia es responsabilidad del establecimiento o de la empresa proveedora?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Para saberlo, el técnico de la empresa proveedora lo debe señalar en la descripción de la contingencia, indicando claramente la causa. Si el motivo no corresponde a responsabilidad del establecimiento o por no haber sucedido lo que se indica, la contingencia debe ser rechazada. 5"
          }
        ]
      },
      {
        "id": "q-4.16",
        "q": "¿Qué pasa si el horario informado en la contingencia no es exacto?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Se puede aceptar una aproximación razonable, siempre que represente fielmente el periodo de afectación del servicio."
          }
        ]
      },
      {
        "id": "q-4.17",
        "q": "¿Qué ocurre si existen diferencias entre lo informado por la empresa y lo observado por el establecimiento?",
        "aBlocks": [
          {
            "type": "p",
            "text": "En estos casos, el establecimiento debe revisar detalladamente la información registrada y, si no corresponde a la realidad, rechazar la contingencia, dejando la justificación respectiva y solicitando a la empresa la corrección del registro."
          }
        ]
      }
    ]
  },
  {
    "sectionId": "sec-5",
    "sectionTitle": "5. EVIDENCIAS Y SITUACIONES ESPECIALES",
    "items": [
      {
        "id": "q-5.1",
        "q": "¿Qué tipo de evidencia es válida para una contingencia?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Documentos, fotografías, registros u otros respaldos que acrediten la situación, cargados en un solo archivo PDF cuando corresponda."
          }
        ]
      },
      {
        "id": "q-5.2",
        "q": "¿Qué hago si no cuento con evidencia para respaldar una contingencia?",
        "aBlocks": [
          {
            "type": "p",
            "text": "En estos casos, la contingencia puede ser rechazada, solicitando a la empresa mayor respaldo o información adicional."
          }
        ]
      },
      {
        "id": "q-5.3",
        "q": "¿La evidencia puede ser solicitada posteriormente?",
        "aBlocks": [
          {
            "type": "p",
            "text": "No. Si la contingencia no tiene la evidencia correspondiente se debe rechazar y el operador tendrá la obligación de subir una nueva contingencia."
          }
        ]
      },
      {
        "id": "q-5.4",
        "q": "¿Quién revisa las evidencias cargadas en SAGEC?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Dependiendo del tipo de contingencia, las revisa el establecimiento, el Ministerio de Educación o SUBTEL."
          }
        ]
      },
      {
        "id": "q-5.5",
        "q": "¿Cómo se registran los cortes del servicio durante vacaciones, feriados o fines de semana?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Se pueden justificar mediante contingencias programadas, siempre que exista acuerdo previo y respaldo correspondiente."
          }
        ]
      },
      {
        "id": "q-5.6",
        "q": "¿Qué pasa con el servicio cuando el establecimiento está cerrado por receso escolar?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El servicio sigue siendo monitoreado y cualquier interrupción debe quedar debidamente registrada."
          }
        ]
      },
      {
        "id": "q-5.7",
        "q": "¿Qué ocurre si el servicio se corta fuera del horario escolar?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El evento igualmente debe registrarse si afecta la continuidad del servicio contratado, pero se ingresa como otro tipo de contingencia que el operador debe generar, la que debe ser revisada por SUBTEL. 6"
          }
        ]
      },
      {
        "id": "q-5.8",
        "q": "¿Qué pasa si el establecimiento estuvo cerrado, por lo tanto los equipos desconectados, y no había personal para atender al técnico?",
        "aBlocks": [
          {
            "type": "p",
            "text": "La empresa proveedora ingresará igualmente la contingencia señalando que no pudo tomar contacto con el establecimiento educacional y aquí es muy importante que el establecimiento pueda verificar la información (receso, vacaciones u otras situaciones excepcionales)."
          }
        ]
      }
    ]
  },
  {
    "sectionId": "sec-6",
    "sectionTitle": "6. FORMULARIOS DE ALTA Y UPGRADE DE SERVICIO (FAS y FUS)",
    "items": [
      {
        "id": "q-6.1",
        "q": "¿Qué es el FAS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El Formulario de Aceptación del Servicio (FAS) es el documento mediante el cual un establecimiento educacional confirma formalmente la correcta instalación y puesta en marcha del servicio de conectividad entregado por la empresa proveedora."
          }
        ]
      },
      {
        "id": "q-6.2",
        "q": "¿Qué es el FUS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El Formulario de Upgrade del Servicio (FUS) es un documento que permite al establecimiento educacional declarar y validar el aumento del ancho de banda obligatorio provisto, confirmando que este se encuentra operativo y disponible para fines educativos. Estas son dos instancias, la primera fue el Upgrade realizado el 2024 para el 2025 y el próximo aplicará el 2028 para el 2029."
          }
        ]
      },
      {
        "id": "q-6.3",
        "q": "¿Cuál es la diferencia entre FUS y FAS?",
        "aBlocks": [
          {
            "type": "ul",
            "items": [
              "El FAS se completa una sola vez, cuando el servicio es instalado y aceptado por el establecimiento.",
              "El FUS, se completa solo para los procesos de Upgrade obligatorio. Estas son dos instancias, la primera fue el Upgrade realizado el 2024 para el 2025 y el próximo aplicará el 2028 para el 2029."
            ]
          }
        ]
      },
      {
        "id": "q-6.4",
        "q": "¿Cuándo debo completar el FAS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El FAS debe completarse una vez que la empresa proveedora haya finalizado la instalación del servicio y el establecimiento haya verificado que este funciona correctamente. Esto corresponde solo al proceso inicial para dejar habilitado el servicio de conectividad."
          }
        ]
      },
      {
        "id": "q-6.5",
        "q": "¿Cuándo corresponde completar el FUS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El FUS se completa durante los periodos definidos por el proyecto, estas son dos instancias, la primera fue el Upgrade realizado el 2024 para el 2025 y el próximo aplicará el 2028 para el 2029."
          }
        ]
      },
      {
        "id": "q-6.6",
        "q": "¿Qué pasa si no completo el FAS o el FUS dentro del plazo?",
        "aBlocks": [
          {
            "type": "p",
            "text": "La no validación del FAS no permite iniciar la formalización del servicio y el respectivo pago del servicio, deteniendo el proceso de todos los establecimientos educacionales de la zona. En el caso del FUS involucra una falta con respecto a la empresa proveedora a pesar de que está haya cumplido."
          }
        ]
      },
      {
        "id": "q-6.7",
        "q": "¿Quién debe completar el FAS y el FUS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "7 Ambos formularios deben ser completados por el establecimiento educacional, a través del Rol Representante (Director/a o Encargado/a de Informática)."
          }
        ]
      },
      {
        "id": "q-6.8",
        "q": "¿Puede otra persona completar el FAS o FUS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "No. Solo los usuarios con Rol Representante pueden completar y enviar estos formularios en la plataforma SAGEC."
          }
        ]
      },
      {
        "id": "q-6.9",
        "q": "¿Dónde encuentro el FAS y el FUS en la plataforma?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Una vez que el establecimiento ingresa a SAGEC, los formularios se encuentran disponibles en el menú correspondiente, según el estado del servicio y el periodo vigente."
          }
        ]
      },
      {
        "id": "q-6.10",
        "q": "¿Qué información debo revisar antes de enviar el FAS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Se debe verificar que el servicio esté correctamente instalado, operativo, realizar un test de velocidad nacional e internacional y que la información registrada por el técnico coincida con la realidad del establecimiento."
          }
        ]
      },
      {
        "id": "q-6.11",
        "q": "¿Qué información declaro al completar el FUS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "El establecimiento declara que el servicio de conectividad ha tenido el aumento de ancho de banda correspondiente, se encuentra disponible y al estándar que corresponde."
          }
        ]
      },
      {
        "id": "q-6.12",
        "q": "¿Qué hago si el servicio no funciona correctamente al momento de completar el FAS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "En ese caso, dentro del FAS debe indicar NO en las preguntas que corresponda, con esto el FAS será rechazado y la empresa deberá solucionar el problema y volver a ingresar el FAS para nueva revisión del establecimiento educacional."
          }
        ]
      },
      {
        "id": "q-6.13",
        "q": "¿Puedo rechazar un FAS o corregir un FUS enviado?",
        "aBlocks": [
          {
            "type": "p",
            "text": "No se puede corregir. Si existe un error, deberá informar a través del correo conectividad@innovacion.mineduc.cl para que la empresa pueda ingresar nuevamente la contingencia."
          }
        ]
      },
      {
        "id": "q-6.14",
        "q": "¿Cómo se relacionan el FUS y las contingencias?",
        "aBlocks": [
          {
            "type": "p",
            "text": "No existe relación entre uno y el otro, ya que son para fines distintos."
          }
        ]
      },
      {
        "id": "q-6.15",
        "q": "¿Debo completar el FUS si el establecimiento estuvo cerrado?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Sí, se debe completar siempre que se solicita."
          }
        ]
      },
      {
        "id": "q-6.16",
        "q": "¿Por qué es importante completar correctamente el FAS y el FUS?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Porque estos formularios constituyen el respaldo formal del funcionamiento y uso del servicio de conectividad, y son utilizados por MINEDUC y SUBTEL para la supervisión del proyecto e iniciar procesos administrativos con las empresas proveedoras."
          }
        ]
      },
      {
        "id": "q-6.17",
        "q": "¿La información enviada en el FAS y FUS tiene carácter oficial?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Sí. La información validada por el establecimiento en SAGEC tiene carácter oficial y administrativo. 8"
          }
        ]
      },
      {
        "id": "q-6.18",
        "q": "¿Qué ocurre si el FAS o FUS se completa con información incorrecta?",
        "aBlocks": [
          {
            "type": "p",
            "text": "Si el establecimiento detecta un error en un FAS o FUS ya enviado, debe informar oportunamente a conectividad@innovacion.mineduc.cl, para informar a la empresa proveedora y pueda volver a ingresarlo."
          }
        ]
      }
    ]
  }
];

const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const getTokens = (query) =>
  Array.from(
    new Set(
      (query || "")
        .toLowerCase()
        .trim()
        .split(/\s+/)
        .map((t) => t.trim())
        .filter(Boolean)
        .filter((t) => t.length >= 2) // evita "a", "de", etc. (ajustable)
    )
  );

function HighlightText({ text, tokens }) {
  if (text === null || text === undefined) return null;
  const str = String(text);

  if (!tokens || tokens.length === 0) return <>{str}</>;

  const pattern = tokens.map(escapeRegExp).join("|");
  if (!pattern) return <>{str}</>;

  const regex = new RegExp(`(${pattern})`, "gi");
  const parts = str.split(regex);

  return (
    <>
      {parts.map((part, i) => {
        const lower = part.toLowerCase();
        const isHit = tokens.some((t) => t.toLowerCase() === lower);

        return isHit ? (
          <Box
            key={i}
            component="mark"
            sx={{
              backgroundColor: "rgba(255, 215, 0, 0.45)",
              padding: "0 0",
              borderRadius: "3px",
            }}
          >
            {part}
          </Box>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        );
      })}
    </>
  );
}

/* =========================
   AnswerBlocks (con highlight)
========================= */

function AnswerBlocks({ blocks, tokens }) {
  return (
    <Stack spacing={1.25}>
      {(blocks || []).map((b, idx) => {
        if (b?.type === "p") {
          return (
            <Typography key={idx} variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
              <HighlightText text={b.text} tokens={tokens} />
            </Typography>
          );
        }

        if (b?.type === "link") {
          return (
            <Typography key={idx} variant="body2">
              <Link
                href={b.href}
                target={b.href?.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
              >
                <HighlightText text={b.text} tokens={tokens} />
              </Link>
            </Typography>
          );
        }

        if (b?.type === "ul") {
          return (
            <Box key={idx} component="ul" sx={{ m: 0, pl: 2.5 }}>
              {(b.items || []).map((it, j) => (
                <Box key={j} component="li" sx={{ mb: 0.5 }}>
                  <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                    <HighlightText text={it} tokens={tokens} />
                  </Typography>
                </Box>
              ))}
            </Box>
          );
        }

        if (b?.type === "ol") {
          return (
            <Box key={idx} component="ol" sx={{ m: 0, pl: 2.5 }}>
              {(b.items || []).map((it, j) => (
                <Box key={j} component="li" sx={{ mb: 0.5 }}>
                  <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                    <HighlightText text={it} tokens={tokens} />
                  </Typography>
                </Box>
              ))}
            </Box>
          );
        }

        return null;
      })}
    </Stack>
  );
}

/* =========================
   Main component
========================= */

export default function SagecFAQ() {
  const { pageTitle, setPageTitle } = useContext(GeneralContext);
  const [query, setQuery] = useState("");
  const [expanded, setExpanded] = useState({}); // { [itemId]: bool }

  const tokens = useMemo(() => getTokens(query), [query]);

  const allItems = useMemo(() => {
    const items = [];
    for (const sec of FAQ_CONTENT) {
      for (const it of sec.items) {
        items.push({ ...it, sectionId: sec.sectionId, sectionTitle: sec.sectionTitle });
      }
    }
    return items;
  }, []);

  const filtered = useMemo(() => {
    if (!tokens.length) return FAQ_CONTENT;

    const matchItem = (it) => {
      const qText = (it.q || "").toLowerCase();

      const textFromBlocks = (it.aBlocks || [])
        .map((b) => {
          if (b.type === "p") return b.text || "";
          if (b.type === "link") return `${b.text || ""} ${b.href || ""}`;
          if (b.type === "ul" || b.type === "ol") return (b.items || []).join(" ");
          return "";
        })
        .join(" ")
        .toLowerCase();

      const haystack = `${qText} ${textFromBlocks}`;

      return tokens.every((t) => haystack.includes(t));

      // return tokens.some((t) => haystack.includes(t));
    };

    return FAQ_CONTENT.map((sec) => ({
      ...sec,
      items: sec.items.filter(matchItem),
    })).filter((sec) => sec.items.length > 0);
  }, [tokens]);

  const expandAll = () => {
    const next = {};
    for (const it of allItems) next[it.id] = true;
    setExpanded(next);
  };

  const collapseAll = () => setExpanded({});

  const toggleOne = (itemId) => {
    setExpanded((prev) => ({ ...prev, [itemId]: !prev[itemId] }));
  };

  const allExpanded = useMemo(() => {
    if (!allItems.length) return false;
    return allItems.every((it) => !!expanded[it.id]);
  }, [expanded, allItems]);

  const handleToggleAll = () => {
    if (allExpanded) collapseAll();
    else expandAll();
  };

  return (
    <>
      <PageBgBlock>
        <Stack spacing={2}>
          {/* Header */}
          <Stack spacing={1}>
            <Typography variant="h1" sx={{ fontWeight: 800 }}>
              Preguntas Frecuentes (FAQ)
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Busca una pregunta o palabras claves. Puedes expandir/colapsar todo.
            </Typography>
          </Stack>

          {/* Controls */}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ sm: "center" }}>
            <TextField
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              size="small"
              fullWidth
              placeholder="Buscar en preguntas y respuestas…"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />

            <Box sx={{ flexShrink: 0, width: { xs: "100%", sm: "260px" } }}>
              <PageButtonBlack
                onClick={handleToggleAll}
                width="100%"
                pad="6px 14px"
                fs="13px"
                icon={allExpanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
              >
                {allExpanded ? "Colapsar todo" : "Expandir todo"}
              </PageButtonBlack>
            </Box>
          </Stack>

          {/* Sections */}
          <Stack spacing={2}>
            {filtered.map((sec) => (
              <Box key={sec.sectionId}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1, mt: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 800 }}>
                    {sec.sectionTitle}
                  </Typography>
                  <Chip size="small" label={`${sec.items.length}`} />
                </Stack>

                <Divider sx={{ mt: 0, mb: 2 }} />

                <Stack spacing={1}>
                  {sec.items.map((it) => (
                    <Accordion
                      key={it.id}
                      expanded={!!expanded[it.id]}
                      onChange={() => toggleOne(it.id)}
                      disableGutters
                      sx={{
                        borderRadius: 2,
                        "&:before": { display: "none" },
                        border: "1px solid",
                        borderColor: "divider",
                        overflow: "hidden",
                      }}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Stack spacing={0.5} sx={{ width: "100%" }}>
                          <Typography sx={{ fontWeight: 700 }}>
                            <HighlightText text={it.q} tokens={tokens} />
                          </Typography>

                          {Array.isArray(it.tags) && it.tags.length > 0 && (
                            <Stack direction="row" spacing={0.75} sx={{ flexWrap: "wrap" }}>
                              {it.tags.map((t) => (
                                <Chip key={t} size="small" variant="outlined" label={t} />
                              ))}
                            </Stack>
                          )}
                        </Stack>
                      </AccordionSummary>

                      <AccordionDetails>
                        <AnswerBlocks blocks={it.aBlocks || []} tokens={tokens} />
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Stack>
              </Box>
            ))}
          </Stack>

          {filtered.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No se encontraron resultados.
            </Typography>
          )}
        </Stack>
      </PageBgBlock>
    </>
  );
}